var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('application-header',{staticClass:"header"}),_c('div',{staticClass:"main"},[_c('router-view')],1),(!_vm.isRenaultEvent())?_c('application-footer',{staticClass:"footer"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }